import type { RouteRecordRaw } from 'vue-router'

// 活动落地页
export const activityRoutes: RouteRecordRaw[] = [
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/pages/Activity/index.vue'),
    meta: { backMode: 'allow' },
  },
]
